import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostCheckoutRecurrence,
	PostCheckoutRecurrenceModel,
	PostCheckoutRecurrenceParams,
} from 'domain/usecases';

export class RemotePostCheckoutRecurrence implements PostCheckoutRecurrence {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostCheckoutRecurrenceModel>,
	) {}

	async post({
		signal,
		...body
	}: PostCheckoutRecurrenceParams): Promise<PostCheckoutRecurrenceModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
